<template>
  <v-tooltip color="dark" top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" color="primary" small>
        fa-question-circle
      </v-icon>
    </template>
    <div v-html="$t(i18n)"></div>
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    i18n: { required: true, type: String },
  },
}
</script>
